<script>
import AppPagination from '@/components/common/AppPagination.vue'
import { getB2bEvidenceRequests, updateB2bEvidenceStatus } from '@/api/b2b.js'

export default {
  name: 'B2bEvidenceRequestPage',
  components: { AppPagination },
  data() {
    return {
      search: { keyword: '', status: '' },
      items: [],
      page: 1,
      size: 10,
      total: 0,
      loading: false,
      statusOptions: [
        { title: '전체', value: '' },
        { title: '요청', value: 'REQUESTED' },
        { title: '발행완료', value: 'ISSUED' },
        { title: '반려', value: 'REJECTED' },
      ],
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    async fetchList() {
      this.loading = true
      try {
        const res = await getB2bEvidenceRequests({
          keyword: this.search.keyword || undefined,
          status: this.search.status || undefined,
          page: this.page,
          size: this.size,
        })
        this.items = res.data?.data?.items || []
        this.total = res.data?.data?.total || 0
      } finally {
        this.loading = false
      }
    },
    async changeStatus(item, status) {
      const memo = window.prompt('처리 메모를 입력하세요.', item.processMemo || '')
      if (memo === null) return
      const res = await updateB2bEvidenceStatus(item.paymentEvidenceRequestCode, { requestStatus: status, processMemo: memo })
      if (res.data?.code === 0) this.fetchList()
    },
    typeText(type) {
      return { TAX_INVOICE: '세금계산서', CASH_RECEIPT: '현금영수증' }[type] || type
    },
    statusText(status) {
      return { REQUESTED: '요청', ISSUED: '발행완료', REJECTED: '반려' }[status] || status
    },
    formatDate(value) {
      return value ? String(value).replace('T', ' ').slice(0, 16) : '-'
    },
  },
}
</script>

<template>
  <div>
    <div class="mb-5">
      <div class="text-h5 font-weight-bold">증빙 발행요청 관리</div>
      <div class="text-body-2 text-grey mt-1">B2B 가상계좌 결제의 세금계산서와 현금영수증 발행요청을 관리합니다.</div>
    </div>

    <v-card rounded="lg" class="mb-5">
      <v-card-text>
        <v-row align="center">
          <v-col cols="12" md="6"><v-text-field v-model="search.keyword" label="검색" placeholder="주문번호, 회원, 업체, 사업자번호" variant="outlined" density="compact" hide-details clearable @keyup.enter="fetchList" /></v-col>
          <v-col cols="12" md="3"><v-select v-model="search.status" :items="statusOptions" label="상태" variant="outlined" density="compact" hide-details /></v-col>
          <v-col cols="12" md="3" class="d-flex justify-end"><v-btn color="primary" prepend-icon="mdi-magnify" @click="fetchList">검색</v-btn></v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card rounded="lg">
      <v-card-title class="text-subtitle-1 font-weight-bold">요청 목록 <v-chip size="small" color="primary" label class="ml-2">{{ total }}건</v-chip></v-card-title>
      <v-progress-linear v-if="loading" indeterminate color="primary" />
      <v-table density="compact">
        <thead><tr><th>요청일</th><th>유형</th><th>상태</th><th>주문/결제</th><th>회원</th><th>업체</th><th>발행정보</th><th class="text-end">처리</th></tr></thead>
        <tbody>
          <tr v-for="item in items" :key="item.paymentEvidenceRequestCode">
            <td>{{ formatDate(item.requestedDt) }}</td>
            <td>{{ typeText(item.evidenceType) }}</td>
            <td><v-chip size="small" color="primary">{{ statusText(item.requestStatus) }}</v-chip></td>
            <td><div>{{ item.orderCode }}</div><div class="text-caption text-grey">{{ item.paymentCode }}</div></td>
            <td><div>{{ item.userName }}</div><div class="text-caption text-grey">{{ item.userEmail }}</div></td>
            <td>{{ item.companyName || '-' }}</td>
            <td>
              <div v-if="item.evidenceType === 'TAX_INVOICE'">{{ item.businessName || '-' }} / {{ item.businessNo || '-' }}</div>
              <div v-else>{{ item.cashReceiptType || '-' }} / {{ item.cashReceiptIdentity || '-' }}</div>
              <div class="text-caption text-grey">{{ item.issueEmail || item.processMemo || '-' }}</div>
            </td>
            <td class="text-end">
              <v-btn size="small" variant="text" color="primary" @click="changeStatus(item, 'ISSUED')">발행완료</v-btn>
              <v-btn size="small" variant="text" color="error" @click="changeStatus(item, 'REJECTED')">반려</v-btn>
            </td>
          </tr>
          <tr v-if="!loading && !items.length"><td colspan="8" class="text-center text-grey py-8">증빙 발행 요청이 없습니다.</td></tr>
        </tbody>
      </v-table>
      <div class="px-4 pb-4"><AppPagination :total="total" :page="page" :size="size" @update:page="p => { page = p; fetchList() }" @update:size="s => { size = s; page = 1; fetchList() }" /></div>
    </v-card>
  </div>
</template>
